<script lang="ts">
  import { goBackOrGoHome } from "@/js/app";
  import { Icon, Link, Navbar } from "framework7-svelte";

  export let title = "";
  export let transparent = false;
</script>

<Navbar title={title} sliding transparent={transparent}>
  <Link slot="left" onClick={goBackOrGoHome}
    ><Icon material={"arrow_back"} /></Link>
</Navbar>
